const StartPage = () => import(/* webpackChunkName: "StartPage" */ "./pages/StartPage.vue");
const ValidationEngineTestPage = () =>
    import(
        /* webpackChunkName: "ValidationEngineTestPage" */ "./pages/ValidationEngineTest/ValidationEngineTestPage.vue"
    );
const pages = [
    {
        path: "/",
        redirect: "/start-page",
    },
    {
        path: "/start-page",
        name: "StartPage",
        component: StartPage,
    },
    {
        path: "/validation-engine-test",
        name: "ValidationEngineTestPage",
        component: ValidationEngineTestPage,
    },
];

export { pages };
